import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducer'; 

// Create store
const store = configureStore({
  reducer: rootReducer,
  
});

export default store;